// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  'The number of visible attributes depends on the size of your browser and screen. Any attributes not shown are visible in the detailed view.':
    'CERTS_COLUMN_FILTER_LABEL',
  Columns: 'CERTS_COLUMNS',
  User: 'User_LABEL.ATTESTATIONS',
  Account: 'Account_LABEL.ATTESTATIONS',
  Entitlement: 'Ent_LABEL.ATTESTATIONS',
  Role: 'Role_LABEL.ATTESTATIONS',
  'Child Entitlement': 'Ent2_LABEL.ATTESTATIONS',
  'Drag to Reorder': 'certs.drag.to.reorder',
};
